@if (!partner?.prospect) {
  <!-- History of the Last 12 Months -->
  <div class="card shadow border-0 mb-3 fade-in-zoom">
    <div class="card-body">
      <h6 class="fw-bold">History of the Last 12 Months</h6>
      @if (loaded) {
        <canvas baseChart
          [data]="last12MonthsChart"
          [type]="lineType"
          [options]="lineOptions"
          width="500" height="250"
          style="display: block; box-sizing: border-box; height: 250px; width: 500px;">
        </canvas>
      } @else {
        <div class="d-flex align-items-center justify-content-center" style="height: 250px;">
          <div class="spinner-border spinner-border-sm text-primary opacity-50" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      }
    </div>
  </div>
  <!-- History of the Last 30 Days -->
  <div class="card shadow border-0 mb-3 fade-in-zoom">
    <div class="card-body">
      <h6 class="fw-bold">History of the Last 30 Days</h6>
      @if (loaded) {
        <canvas baseChart
          [data]="last30daysChart"
          [type]="barType"
          [options]="barOptions"
          width="500" height="250"
          style="display: block; box-sizing: border-box; height: 250px; width: 500px;">
        </canvas>
      } @else {
        <div class="d-flex align-items-center justify-content-center" style="height: 250px;">
          <div class="spinner-border spinner-border-sm text-primary opacity-50" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      }
    </div>
  </div>
  <!-- Ongoing Month -->
  <div class="card shadow border-0 fade-in-zoom">
    <div class="card-header fw-bold bg-tertiary p-3 border-0 d-flex justify-content-between align-items-center">
      <span><i class="bi bi-lightning-fill me-2 text-primary"></i>Monthly flash KPIs</span>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 d-flex justify-content-between border-bottom py-2">
          <span class="fw-bold small">NUMBER OF LEADS</span>
          @if (loaded) {
            <span class="fw-bold">{{ partnerStat.currentMonth.lead }}</span>
          } @else {
            <span class="spinner-border spinner-border-sm text-primary opacity-50" role="status"><span class="visually-hidden">Loading...</span></span>
          }
        </div>
        <div class="col-12 d-flex justify-content-between bg-light border-bottom py-2">
          <span class="fw-bold small">AVERAGE REVENUE / LEAD</span>
          @if (loaded) {
            <span class="fw-bold">{{ partnerStat.currentMonth.averageRevenue | money }}</span>
          } @else {
            <span class="spinner-border spinner-border-sm text-primary opacity-50" role="status"><span class="visually-hidden">Loading...</span></span>
          }
        </div>
        <div class="col-12 d-flex justify-content-between py-2">
          <span class="fw-bold small">TOTAL SALES</span>
          @if (loaded) {
            <span class="fw-bold">{{ partnerStat.currentMonth.totalSales | money }}</span>
          } @else {
            <span class="spinner-border spinner-border-sm text-primary opacity-50" role="status"><span class="visually-hidden">Loading...</span></span>
          }
        </div>
      </div>
    </div>
  </div>
}
